import FormSelect from '@/components/Forms/FormSelect'
import { mapGetters } from 'vuex'
import { getEffectiveDatesRange } from '@/components/composables/useEffectiveDatesRange'
import useSections from '@sy/client/composables/useSections'

export default {
  extends: FormSelect,
  props: {
    formValue: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      sectionsLoaded: false,
    }
  },
  setup () {
    const { sections, fetchSectionsByCmCourse } = useSections()
    return { sections, fetchSectionsByCmCourse }
  },
  computed: {
    ...mapGetters([ 'school', 'termById' ]),
    ...mapGetters('curriculumCourses', [ 'cmCourseByEffectiveDatesRangeLookup' ]),
    courseId () {
      return this.formValue.course
    },
    term () {
      return this.termById(this.formValue.startTerm)
    },
    effectiveDatesRange () {
      return getEffectiveDatesRange(this.formValue)
    },
    course () {
      return this.cmCourseByEffectiveDatesRangeLookup(
        this.courseId,
        this.effectiveDatesRange,
      )
    },
    normalizedOptions () {
      const sectionOptions = this.sections.map(section => section.sectionNumber).filter(Boolean)
      return [ ...new Set(sectionOptions) ].sort()
    },
  },
  watch: {
    term () {
      this.sectionsLoaded = false
    },
    courseId () {
      this.sectionsLoaded = false
    },
    isOpen: {
      async handler (val) {
        if (val && !this.sectionsLoaded) {
          if (!this.courseId) return
          this.isLoading = true
          await this.fetchSectionsByCmCourse({
            school: this.school,
            course: this.course,
            term: this.term,
          })
          this.sectionsLoaded = true
          this.isLoading = false

        }
      },
    },
  },
}
